import React, { useEffect, useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline } from "@mui/material";
import { observer } from "mobx-react-lite";
import { theme } from "./theme/theme";
import { authStore } from "./stores";
import LoginForm from "./components/LoginForm";
import AppLayout from "./components/AppLayout";
import ChangePasswordDialog from "./components/ChangePasswordDialog";

const App: React.FC = observer(() => {
    const [showChangePassword, setShowChangePassword] = useState(false);

    useEffect(() => {
        // Проверяем, нужно ли показать диалог смены пароля
        if (authStore.isAuthenticated && authStore.user?.mustChangePassword) {
            setShowChangePassword(true);
        } else {
            setShowChangePassword(false);
        }
    }, [authStore.isAuthenticated, authStore.user?.mustChangePassword]);

    const handlePasswordChanged = () => {
        setShowChangePassword(false);
    };

    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            {authStore.isAuthenticated ? (
                <>
                    <AppLayout />
                    <ChangePasswordDialog
                        open={showChangePassword}
                        onClose={handlePasswordChanged}
                        required={authStore.user?.mustChangePassword === true}
                    />
                </>
            ) : (
                <LoginForm />
            )}
        </ThemeProvider>
    );
});

export default App;
